export default "__VITE_ASSET__BVvO8x$s__";